// third party provider natively supported by Firebase (e.g. Intuit SSO is not supported)
export enum SsoProvider {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  OIDC = 'OIDC',
  SAML = 'SAML',
}

/** The provider types an organization configures for itself, each identified by its own provider ID. */
export type EnterpriseSsoProvider = SsoProvider.OIDC | SsoProvider.SAML;
